import * as Actions from '../actions';

const initialState = {
	list: [],
	credential: null,
	selected: null,
	searchText: '',
	error: null
};

const credentialReducer = (state = initialState, action) => {
	switch (action.type) {		// Log the action	switch (action.type) {
		case Actions.SET_CREDENTIALS_LIST: {
			return {
				...state,
				error: null,
				list: action.payload
			};
		}
		case Actions.SET_CREDENTIAL: {
			return {
				...state,
				credential: action.payload,
				error: null
			};
		}

		case Actions.SET_SELECTED: {
			return {
				...state,
				selected: action.payload
			};
		}
		case Actions.SET_SEARCH_TEXT: {
			return {
				...state,
				searchText: action.searchText
			};
		}
		case Actions.SET_CREDENTIAL_ERROR: {
			return {
				...state,
				error: action.payload
			};
		}
		case Actions.CLEAR_ERROR: {
			return {
				...state,
				error: null
			};
		}
		case Actions.CLEAR_CREDENTIAL: {
			return {
				...state,
				credential: null
			};
		}
		case Actions.CLEAR_CREDENTIALS_REDUCER: {
			return initialState;
		}
		default: {
			return state;
		}
	}
};

export default credentialReducer;
